/* KOS-Overlay (snippets/kos-overlay.liquid).
   Baut beim ersten Öffnen die Karten der kommenden KOS, füllt mit KOS-on-Demand-Aufzeichnungen auf
   und hängt pro Karte bei Klick ein Formular per createForm() (snippets/dynamic-form-js.liquid) an.
   Geöffnet wird über #myBtn, auch durch assets/overlay-time-trigger.js.
   Variante: <html data-kos-variant> ("1" | "2", gesetzt per Event kos-overlay:variant) öffnet statt
   dieses Modals die Variante aus assets/kos-overlay-variants.js, sonst "default" (dieses Modal). */
(function () {
  "use strict";

  var dataEl = document.querySelector("[data-kos-overlay-data]");
  var modal = document.getElementById("myModal");
  var openBtn = document.getElementById("myBtn");
  if (!dataEl || !modal || !openBtn) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (error) {
    console.error("KOS-Overlay: Daten konnten nicht gelesen werden", error);
    return;
  }

  var container = modal.querySelector(".kos__Element__Container");
  var closeBtn = modal.querySelector(".close");
  var upcoming = toArray(data.upcoming);
  var onDemand = toArray(data.onDemand);
  var formConfigs = new WeakMap();
  var isBuilt = false;
  var activeVariant = null;
  var VARIANTS = ["1", "2"];

  var WEBHOOK = "https://hooks.zapier.com/hooks/catch/590116/3wrzncq/";
  var SHOPIFY_CDN = /^https:\/\/cdn\.shopify\.com\//;
  var ON_DEMAND_URL = "https://education.omr.com/pages/kostenlose-online-seminare-aufzeichnungen#kos_uebersicht";
  var DOI_EDUCATION =
    "Die Anmeldung zum kostenlosen Online-Seminar war erfolgreich! Der Kalendereintrag mit deinem persönlichen Zugangslink ist auch schon auf dem Weg zu dir. Damit wir dir nach dem Online-Seminar die Aufzeichnung und die Slides zusenden können, bestätige bitte über den Button die Anmeldung zum OMR Education Newsletter.";
  var DOI_HR =
    "die Anmeldung zum kostenlosen Online-Seminar war erfolgreich! Der Kalendereintrag mit deinem persönlichen Zugangslink ist auch schon auf dem Weg zu dir. Damit wir dir nach dem Online-Seminar die Aufzeichnung und die Slides zusenden können, bestätige bitte über den Button die Anmeldung zum OMR HR Newsletter.";
  var DOI_ON_DEMAND =
    "Die Anmeldung zum kostenlosen Online-Seminar war erfolgreich! Solltest du noch kein Newsletter-Subscriber sein, bestätige bitte die Mail, die wir dir gerade geschickt haben.";

  function toArray(value) {
    if (value === null || value === undefined) return [];
    return Array.isArray(value) ? value : [value];
  }

  function isFutureDate(dateString) {
    return new Date(dateString) > new Date();
  }

  function formatDate(dateString) {
    var date = new Date(dateString);
    var day = (date.getDate() < 10 ? "0" : "") + date.getDate();
    var month = (date.getMonth() < 9 ? "0" : "") + (date.getMonth() + 1);
    return day + "." + month + "." + date.getFullYear();
  }

  function announcementMessage(dateString) {
    var diff = new Date(dateString) - new Date();
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var prefix = "<p>Jetzt noch schnell anmelden: <br>";
    var prefixShort = "<p>Jetzt noch schnell anmelden:  <br>";

    if (days >= 7) return "<b>In " + days + " Tagen geht's los.</b>";
    if (days >= 3) return prefix + "In <b>" + days + "</b> Tagen geht's los.</p>";
    if (days === 2) return prefix + "<b>Übermorgen</b> geht's los.</p>";
    if (days === 1) return prefix + "<b>" + (hours >= 24 ? "Übermorgen" : "Morgen") + "</b> geht's los.</p>";
    if (days === 0) {
      if (hours >= 2) return prefixShort + "In <b>" + hours + "</b> Stunden geht's los.</p>";
      if (hours === 1) return prefixShort + "In <b>" + hours + "</b> Stunde geht's los.</p>";
      if (minutes > 1) return prefixShort + "In <b>" + minutes + "</b> Minuten geht's los.</p>";
      return prefixShort + "Es geht <b>jetzt</b> los.</p>";
    }
    return "";
  }

  // Themen-Metafield der Collection kommt als Liste ("[\"ki\"]") und wird zu "ki" bereinigt
  function getCollectionTopic() {
    return String(data.topic || "").replace(/["\[\]]/g, "");
  }

  function getUtmTopic() {
    try {
      var utmParams = JSON.parse(localStorage.getItem("utm-params"));
      if (utmParams && Object.prototype.hasOwnProperty.call(utmParams, "topic")) return utmParams.topic;
    } catch (error) {
      // ungültige oder fehlende UTM-Parameter
    }
    return "";
  }

  function toTime(germanDate) {
    return new Date(germanDate.split(".").reverse().join("-"));
  }

  // Neueste Aufzeichnung, deren kos_match dem Thema entspricht, sonst null
  function findLatestByTopic(topic) {
    var matches = onDemand.filter(function (item) {
      return item.kos_match === topic;
    });
    if (matches.length === 0) return null;
    return matches.reduce(function (latest, current) {
      return toTime(current.date) > toTime(latest.date) ? current : latest;
    });
  }

  /**
   * Aufzeichnungen, die nach den kommenden KOS angezeigt werden.
   * @param {number} kosCount - Anzahl der kommenden KOS
   * @returns {Array} Aufzeichnungen in Anzeigereihenfolge
   */
  function selectOnDemand(kosCount) {
    var utmTopic = getUtmTopic();
    var collectionTopic = getCollectionTopic();
    var match = null;

    if (utmTopic !== "") match = findLatestByTopic(utmTopic);
    if (match === null && collectionTopic !== "") match = findLatestByTopic(collectionTopic);

    if (match === null) return kosCount < 3 ? onDemand.slice(0, 3 - kosCount) : [];

    var slots = kosCount > 3 ? 0 : kosCount >= 2 ? 1 : 3 - kosCount;
    var others = onDemand.filter(function (item) {
      return item.id !== match.id;
    });
    return [match].concat(others).slice(0, slots);
  }

  /**
   * Alle Einträge des Overlays in Anzeigereihenfolge: kommende KOS, danach aufgefüllte Aufzeichnungen.
   * @returns {Array<{type: string, index: number, source: Object, modifier: string, form: Array}>}
   */
  function getItems() {
    var items = [];

    upcoming.forEach(function (webinar, index) {
      if (!isFutureDate(webinar.timefull)) return;
      items.push({
        type: "upcoming",
        index: index,
        source: webinar,
        title: webinar.fulltitle,
        description: webinar.description,
        image: webinar.imageurl,
        startsAt: webinar.timefull,
        time: webinar.time,
        speaker: webinar.speaker_main || webinar.speaker || "",
        jobtitle: webinar.jobtitle_main || "",
        url: webinar.landingpageurl,
        modifier: "kosOverlayForm" + index,
        form: upcomingFormConfig(webinar),
      });
    });

    selectOnDemand(items.length).forEach(function (kos, index) {
      items.push({
        type: "ondemand",
        index: index,
        source: kos,
        title: kos.headline,
        description: kos.text,
        image: kos.thumbimage,
        startsAt: "",
        time: "",
        speaker: kos.speakers || "",
        jobtitle: "",
        url: ON_DEMAND_URL,
        modifier: "kosOnDemandOverlayForm" + index + "0",
        form: onDemandFormConfig(kos),
      });
    });

    return items;
  }

  function formFields() {
    return [
      {
        row: [
          {
            type: "text",
            urlparamname: "firstname",
            label: "Vorname",
            placeholder: "Dein Vorname",
            error: "Bitte trage deinen Vornamen ein",
            required: "true",
          },
        ],
      },
      {
        row: [
          {
            type: "email",
            urlparamname: "email",
            label: "E-Mail",
            placeholder: "Deine E-Mail",
            error: "Bitte trage deine E-Mail ein",
            required: "true",
          },
        ],
      },
      {
        row: [
          {
            type: "math",
            label: "Validierung",
            urlparamname: "math",
            placeholder: "Bitte löse diese Matheaufgabe",
            error: "Bitte zeige uns, dass du kein Bot bist und löse diese Matheaufgabe",
            required: "true",
          },
        ],
      },
    ];
  }

  function formConfig(successMessage, additionalParams) {
    return [
      {
        fields: formFields(),
        headlines: { headline: " " },
        agb: { text: "Mit dem Absenden stimmst du unserer Datenschutzerklärung zu." },
        button: { text: "Absenden" },
        success: { icon: "✔️", message: successMessage, filedownoad: "", buttontext: "", url: "" },
        tracking: { webhook: WEBHOOK, additionalparams: additionalParams },
        background: {
          desktopleft: "",
          desktopright: "",
          laptopleft: "",
          laptopright: "",
          tabletleft: "",
          tabletright: "",
          mobileleft: "",
          mobileright: "",
        },
        color: "",
      },
    ];
  }

  function upcomingFormConfig(webinar) {
    var isHr = webinar.webinarid.includes("hr_");
    return formConfig(
      "Danke das hat geklappt. Der Kalendereintrag mit deinem persönlichen Zugangslink ist bereits auf dem Weg zu dir.",
      [
        { key: "list", value: isHr ? "OMR HR" : "OMR_Education" },
        { key: "utm_content", value: "kos-overlay-form" },
        { key: "doimessage", value: isHr ? DOI_HR : DOI_EDUCATION },
        { key: "webinarid", value: webinar.webinarid },
        { key: "kosname", value: webinar.webinarTag },
      ],
    );
  }

  function onDemandFormConfig(kos) {
    return formConfig("Dein Videolink ist bereits auf dem Weg zu dir.", [
      { key: "list", value: "OMR Education" },
      { key: "utm_content", value: "kos_oD" },
      { key: "doimessage", value: DOI_ON_DEMAND },
      { key: "kosondemandvideoid", value: kos.id },
      { key: "speakers", value: kos.speakers },
      { key: "kosname", value: kos.webinarname },
    ]);
  }

  // Hängt bei Shopify-CDN-URLs den Breitenparameter an, andere URLs bleiben unverändert
  function cdnWidth(url, width) {
    if (!SHOPIFY_CDN.test(url)) return url;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  // Kartenbild: 320px ab 768px, darunter calc(100vw - 40px) (max. ~727px, ~1454px bei 2x DPR)
  function imageAttributes(url) {
    if (!SHOPIFY_CDN.test(url)) return `src="${url}"`;
    var srcset = [320, 640, 960, 1440]
      .map(function (width) {
        return cdnWidth(url, width) + " " + width + "w";
      })
      .join(", ");
    return `src="${cdnWidth(url, 320)}" srcset="${srcset}" sizes="(max-width: 767px) calc(100vw - 40px), 320px"`;
  }

  function renderUpcomingCard(webinar, index) {
    var message = announcementMessage(webinar.timefull);
    var background = message ? "var(--custom-color-yellow)" : "";

    var wrapper = document.createElement("div");
    wrapper.classList.add("kos__Element__Wrapper");
    wrapper.id = "kos__Element__Wrapper__" + index;

    var card = document.createElement("div");
    card.classList.add("kos__Element");
    card.id = "kos__Element__" + index;
    card.setAttribute("data-formmodifier", "kosOverlayForm");
    card.setAttribute("data-formid", "kos__Element");
    card.setAttribute("data-formstate", "false");
    card.innerHTML = `
        <div class="kos__Anouncement" id="kos__Announcement__${index}" style="background-color: ${background}">${message}</div>
        <a href="${webinar.landingpageurl}" target="_blank" rel="noopener noreferrer" >
        <picture>
        <img
        id="kos__Image__${index}"
        alt="Webinar ${index + 1} banner"
        ${imageAttributes(webinar.imageurl)}
        loading="lazy"
        width="320"
        height="320"
        >
        </picture>
        </a>
        <div class="kos__Description__Wrapper" id="kos__Description__Wrapper__${index}" style="display: none">
        <div class="kos__DescriptionClose__Wrapper"><div class="descriptionClose" id="descriptionClose__${index}" data-action="toggle-info" data-index="${index}">X</div></div>
        <div class="kos__Description" id="kos__">${webinar.description}</div>
        <div class="kos__TriangleDown" id="kos__TriangleDown__${index}"></div>
        </div>
        <div class="kos__Content__Wrapper" id="kos__Content__Wrapper__${index}">
        <div class="kos__Title" id="kos__Title__${index}">${webinar.fulltitle}</div>
        <div class="kos__MoreInfo" id="kos__MoreInfo__${index}" data-action="toggle-info" data-index="${index}">Mehr Infos</div>
        <div class="kos__Date" id="kos__Date__${index}">${formatDate(webinar.timefull)} von ${webinar.time}</div>
        </div>
        <div class="kos__Btn__Wrapper">
        <div class="kos__Btn" id="kos__Btn__${index}" data-action="show-form" data-form-index="${index}">Jetzt Kostenlos anmelden</div>
        </div>
        <div class="kos__FormWrapper" id="kos__FormWrapper__${index}"></div>
    `;
    formConfigs.set(card, upcomingFormConfig(webinar));

    var outerFormWrapper = document.createElement("div");
    outerFormWrapper.classList.add("kos__FormWrapper");
    outerFormWrapper.id = "kos__FormWrapper__" + index;

    wrapper.appendChild(card);
    wrapper.appendChild(outerFormWrapper);
    container.appendChild(wrapper);
  }

  function renderOnDemandCard(kos, index) {
    var wrapper = document.createElement("div");
    wrapper.classList.add("kos__Element__Wrapper");
    wrapper.id = "kosOnDemand__Element__Wrapper__" + index;
    wrapper.innerHTML = `

<div class="kos__Element" id="kosOnDemand__Element__${index}" data-formmodifier="kosOnDemandOverlayForm${index}"
        data-formid="kosOnDemand__Element" data-formstate="false">
        <div class="kos__Anouncement" id="kosOnDemand__Announcement__${index}" style="background-color: var(--custom-color-yellow)"><p style="font-weight: bold">Jetzt direkt anschauen</p></div>
        <a href="${ON_DEMAND_URL}" target="_blank" rel="noopener noreferrer" >
        <picture>
        <img id="kosOnDemand__Image__${index}" alt="Webinar 1 banner" ${imageAttributes(kos.thumbimage)} loading="lazy" width="320" height="320">
        </picture>
        </a>
        <div class="kos__Description__Wrapper" id="kosOnDemand__Description__Wrapper__${index}" style="display: none">
        <div class="kos__DescriptionClose__Wrapper"><div class="descriptionClose" id="descriptionClose__${index}">X</div></div>
        <div class="kos__Description" id="kosOnDemand__${index}"></div>
        <div class="kos__TriangleDown" id="kosOnDemand__TriangleDown__${index}"></div>
        </div>
        <div class="kos__Content__Wrapper" id="kosOnDemand__Content__Wrapper__${index}">
        <div class="kos__Title" id="kosOnDemand__Title__${index}">${kos.headline}</div>
        <div class="kos__MoreInfo" id="kosOnDemand__MoreInfo__${index}" style="text-decoration: none; cursor: auto">${kos.text}</div>
        <div class="kos__Date" id="kosOnDemand__Date__${index}"></div>
        </div>
        <div class="kos__Btn__Wrapper">
        <div class="kos__Btn" id="kosOnDemand__Btn__${index}" data-action="show-form" data-form-index="0">Jetzt anschauen</div>
        </div>
        <div class="kos__FormWrapper" id="kosOnDemand__FormWrapper__${index}"></div>
    </div>


`;
    formConfigs.set(wrapper.querySelector(".kos__Element"), onDemandFormConfig(kos));
    container.appendChild(wrapper);
  }

  function switchToOnDemandHeadlines() {
    modal.querySelector(".kos__Headline").innerText = "Kostenlose Online Seminar Aufzeichnungen";
    modal.querySelector(".kos__Subheadline").innerText =
      "Jetzt eintragen und sofort deinen persönlichen Zugangslink per E-Mail erhalten.";
  }

  function build() {
    var items = getItems();

    if (!items.some(isUpcoming)) switchToOnDemandHeadlines();

    items.forEach(function (item) {
      if (isUpcoming(item)) renderUpcomingCard(item.source, item.index);
      else renderOnDemandCard(item.source, item.index);
    });
  }

  function isUpcoming(item) {
    return item.type === "upcoming";
  }

  function toggleInfo(index) {
    var description = modal.querySelector("#kos__Description__Wrapper__" + index);
    if (!description) return;
    description.style.display = description.style.display === "" ? "none" : "";
  }

  // Ersetzt den Anmelde-Button einer Karte durch das Formular und passt dessen Abstände an
  function showForm(card, index) {
    var width = card.clientWidth;
    var btnWrapper = card.querySelector(".kos__Btn__Wrapper");
    if (btnWrapper) card.removeChild(btnWrapper);

    var config = formConfigs.get(card);
    if (!config || card.getAttribute("data-formstate") !== "false") return;
    card.setAttribute("data-formstate", "true");

    var formWrapper = card.querySelector(".kos__FormWrapper");
    createForm(formWrapper.id, config, card.getAttribute("data-formmodifier") + index);

    var formBox = card.querySelector(".contactformbox");
    if (formBox) {
      var formTitle = formBox.querySelector(".contactform__title");
      if (formTitle) formBox.removeChild(formTitle);
      formBox.parentNode.style.gap = "1rem";
    }

    var spacer = card.querySelector(".constformbox");
    if (spacer) spacer.style.display = "none";

    var form = card.querySelector(".contactform");
    if (form) form.style.width = width - 20 + "px";

    var consentText = card.querySelector(".contactform__consent .contactform__agb p");
    if (consentText) {
      consentText.style.padding = "0px";
      consentText.style.margin = "0px";
    }
  }

  // Variante wird beim ersten Öffnen festgelegt und gilt für die restliche Seitenansicht
  function resolveVariant() {
    if (activeVariant !== null) return activeVariant;
    var requested = document.documentElement.getAttribute("data-kos-variant");
    var isAvailable = VARIANTS.indexOf(requested) !== -1 && window.KosOverlayVariants;
    activeVariant = isAvailable ? requested : "default";
    return activeVariant;
  }

  function reportOpened() {
    if (typeof pushEventToDataLayer === "function") {
      pushEventToDataLayer("OverlayOpened", "", window.location.href, "");
    }
    sessionStorage.setItem("OverlayOpened", "true");
    document.dispatchEvent(new CustomEvent("OverlayOpened"));
  }

  function reportClosed(eventName) {
    if (typeof pushEventToDl === "function") pushEventToDl(eventName, window.location.href, "");
  }

  function open() {
    var variant = resolveVariant();
    if (variant !== "default") {
      window.KosOverlayVariants.open(variant, {
        getItems: getItems,
        formatDate: formatDate,
        cdnWidth: cdnWidth,
        onClose: reportClosed,
      });
      reportOpened();
      return;
    }

    if (!isBuilt) {
      isBuilt = true;
      try {
        build();
      } catch (error) {
        console.error("KOS-Overlay: Karten konnten nicht erstellt werden", error);
      }
    }

    modal.style.display = "block";
    reportOpened();
  }

  function close(eventName) {
    modal.style.display = "none";
    reportClosed(eventName);
  }

  openBtn.addEventListener("click", open);

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      close("OverlayClosedX");
    });
  }

  modal.addEventListener("click", function (event) {
    if (event.target === modal) {
      close("OverlayClosedOutsideModal");
      return;
    }

    var trigger = event.target.closest("[data-action]");
    if (!trigger || !modal.contains(trigger)) return;

    if (trigger.dataset.action === "toggle-info") toggleInfo(trigger.dataset.index);
    if (trigger.dataset.action === "show-form") {
      showForm(trigger.closest(".kos__Element"), trigger.dataset.formIndex);
    }
  });

  openBtn.style.display = "";
  openBtn.classList.add("show");
})();
